module.exports = __webpack_public_path__ + "img/close.e8203288.svg";